import React from 'react'
import i18n from 'src/shared/i18n'
import {isUsp} from 'src/shared/utils'

import {DOWNLOAD_YANGO_APP} from './consts'
import type {PromoProps} from './types'
import YangoPromoBase from './YangoPromoBase'

const YangoPromo: React.FC<PromoProps> = ({fullWidth, onClick, deeplink}) => {
  const isUspService = isUsp()
  const text = isUspService ? i18n.print('route_promo_text_usp') : i18n.print('route_promo_text')

  return <YangoPromoBase fullWidth={fullWidth} link={deeplink || DOWNLOAD_YANGO_APP} onClick={onClick} text={text} />
}

export default YangoPromo
